import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class MetaService {
  constructor(private meta: Meta, private title: Title) {}

  updateTags({
               title,
               description,
               image,
               url,
               type = 'website'
             }: {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
    type?: string;
  }) {
    if (title) this.title.setTitle(title);

    if (description) {
      this.meta.removeTag(`property="og:description"`);
      this.setOrUpdateTag('name', 'description', description);
      this.setOrUpdateTag('property', 'og:description', description);
      this.setOrUpdateTag('name', 'twitter:description', description);
    }

    if (title) {
      this.meta.removeTag(`property="og:title"`);
      this.setOrUpdateTag('property', 'og:title', title);
      this.setOrUpdateTag('name', 'twitter:title', title);
    }

    if (image) {
      this.meta.removeTag(`property="og:image"`);
      this.setOrUpdateTag('property', 'og:image', image);
      this.setOrUpdateTag('name', 'twitter:image', image);
    }

    if (url) this.setOrUpdateTag('property', 'og:url', url);

    this.setOrUpdateTag('property', 'og:type', type);
  }

  private setOrUpdateTag(attr: 'name' | 'property', attrValue: string, content: string) {
    this.meta.removeTag(`${attr}="${attrValue}"`);
    this.meta.addTag({ [attr]: attrValue, content });
  }
}
